const footerTemplate = (method, issuerId, step, templateId, btnText) => `
  <button type="button" class="btn btn-default" data-dismiss="modal">No</button>
  <a data-method=${method} class="button btn btn-default" href="/issuers${issuerId}${step}${templateId}" rel="nofollow" data-dismiss="modal">
      <button class="btn btn-primary">${btnText}</button>
  </a>
`;
export default footerTemplate;
